import { Component } from '@angular/core';
import { NavController, NavParams, ModalController, LoadingController } from 'ionic-angular';
import * as _ from 'lodash';
import * as moment from 'moment';
import * as Highcharts from 'highcharts';

import { Location } from '../../models/location';
import { Data } from '../../providers/providers';
import { Carbohydrate } from '../../providers/providers';
import { AboutCarbohydratePage } from "../about-carbohydrate/about-carbohydrate";

@Component({
  selector: 'page-location-carbohydrate',
  templateUrl: 'location-carbohydrate.html'
})
export class LocationCarbohydratePage {

  location: Location;
  Highcharts = Highcharts;

  public showColumns: any[];

  constructor(public navCtrl: NavController,
              public navParams: NavParams,
              public data: Data,
              public carbohydrate: Carbohydrate) {
    this.location = this.navParams.get('location');

    this.showColumns = [
      'date',
      'maxt',
      'mint',
      'srad',
      'thinIndex',
      'avg7day',
      'dd4cAccum',
      'efficacy',
      'recommend'
    ];
  }

  columnSelected(cols) {
    return _.some(this.showColumns, (col) => _.indexOf(cols, col) != -1);
  }

  howManyColumnsSelected(cols) {
    let val = 0;
    for (let col of this.showColumns) {
      if (_.indexOf(cols, col) != -1) {
        val += 1;
      }
    }
    return val;
  }

  ngAfterViewInit() {
    this.carbohydrate.fetchResults(this.location);
  }

  getMissingCarbohydrateFields() {
    const fields = []
    _.each([
      {field: 'year', label: 'Year'},
      {field: 'farm', label: 'Farm'},
      {field: 'variety', label: 'Variety'},
      {field: 'weather_station_title_dummy', label: 'Weather Station'},
      {field: 'green_tip_date', label: 'Green Tip Date'},
      {field: 'bloom_date', label: 'Bloom Date'},
      {field: 'pct_spurs_flowering', label: 'Percent Spurs Flowering'}
    ], (f) => {
      if (!this.location[f.field]) {
        fields.push(f.label)
      }
    })
    return fields.join(', ')
  }

  endDateChanged() {
    this.carbohydrate.fetchResults(this.location);
  }

  rowIsForEndDate(row) {
    return moment(row.date).isSame(this.carbohydrate.endDate, 'day');
  }

  rowIsOnOrAfterEndDate(row) {
    return moment(row.date).isSameOrAfter(this.carbohydrate.endDate, 'day');
  }

  getEfficacyColumnClass(row) {
    let name = row.efficacy;
    if (name == 'Very Good') {
      name = 'Very-Good';
    }
    return `efficacy-${name}`;
  }

  getDegreeDayColumnClass(row) {
    return (row.dd4cAccum >= 200 && row.dd4cAccum <= 250 ? 'degree-days-green' : '')
  }

  getRecommendationColumnClass(row) {
    return `recommendation-risk-${row.riskColor}`
  }

  openAbout() {
    this.navCtrl.push(AboutCarbohydratePage, {});
  }

}




// WEBPACK FOOTER //
// ./src/pages/location-carbohydrate/location-carbohydrate.ts